import { Box, forwardRef, HStack, HTMLChakraProps, chakra, Tooltip } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

import { useNavigationRailStore } from '../NavigationRail/NavigationRail.store';

export interface IEventNavigationItemProps extends HTMLChakraProps<'div'> {
  isActive?: boolean;
  Icon?: ReactNode;
  enableTooltip?: boolean;
}

export const EventNavigationItem: FC<IEventNavigationItemProps> = forwardRef(
  ({ Icon, isActive, children, enableTooltip, ...rest }, ref) => {
    const isExpanded = useNavigationRailStore((state) => state.isExpanded);

    return (
      <Tooltip isDisabled={!enableTooltip} label={children} placement="right" offset={[0, 16]}>
        <HStack
          as="a"
          spacing={{ base: 4, lg: 2 }}
          alignItems="center"
          aria-current={isActive ? 'page' : null}
          _hover={{ fontFamily: 'underline', '& > span': { bgColor: 'gray.50' } }}
          _activeLink={{ color: 'violet.500', '& > span': { bgColor: 'violet.50' } }}
          minH="3.5rem"
          ref={ref}
          {...rest}
        >
          <chakra.span h="3.5rem" w="3.5rem" p="4" borderRadius=".5rem" pointerEvents="none" flexShrink={0}>
            {Icon}
          </chakra.span>
          <Box
            display={{ lg: isExpanded ? 'block' : 'none' }}
            w={{ lg: '6.5rem' }}
            flexShrink={{ base: 1, lg: 0 }}
            minW={0}
            fontWeight="medium"
            overflowWrap="anywhere"
          >
            {children}
          </Box>
        </HStack>
      </Tooltip>
    );
  }
);
